import React from "react";
import Footer from "../Footer";
import Header from "./Header";
import "../App.css";
import { Link } from "react-router-dom";

function About() {
document.title='HR School - About'
  return (
    <div>
      <Header />
      <section
        id="page-banner"
        class="pt-105 pb-110 bg_cover"
        data-overlay="8"
        style={{backgroundImage: "url(images/page-banner-1.jpg)"}}
      >
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="page-banner-cont">
                <h2>About Us</h2>
                <nav aria-label="breadcrumb">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                      <Link to="/">Home</Link>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">
                      About Us
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>
      <center>
        <div className="about-content" style={{ alignItems: "center" }}>
          <div>
            <h1>
               Front End Developer | Content
              Writer | Freelancer
            </h1>
            <p> Front End Developer</p>
            <div className="first divv">
              <p>Address:Near Post Rohtak(124001)</p>
            </div>
            <div className="second divv">
              <p>Mobile No. +91 0000000000</p>
            </div>
            <div className="third divv">
              <p>Email: samridhisofficial@gmail.com </p>
            </div>
            <p>
              {/* I can declare proudly that I am an experienced expert Search
              Engine Optimizer with more than 6 years experience in both
              “On-Page” and “Off-Page” Search Engine Optimization. I worked on
              30+ live projects And now the ranking of these keywords is in the
              top 10. I have excellent experience in 10+ modules of digital
              marketing (SEO, Google ADS, Webmaster, Keywords Planner, Content
              Creator, Social Media Marketing, Search Engine Marketing, ETC). I */}
             I have 6 months of experience in front-end developer and am now
              learning more skills. I'm always interested in learning the best
              skills. I have created more than 10 websites and also made some
              software. I have worked as a front-end developer and I have 10+
              skills in front-end developer (HTML, CSS, JavaScript, DOM
              manipulation, JSON, AJAX, Node.js, MySQL, React, Java, and web
              performance optimization)
            </p>
          </div>

          <br />
          <br />
          <br />
        </div>{" "}
      </center>
      <div>
        <section
          id="testimonial"
          className="bg_cover pt-115 pb-120"
          data-overlay={8}
          style={{ backgroundImage: "url(images/bg-2.jpg)" }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <div className="section-title pb-40">
                  <h5>Testimonial</h5>
                  <h2>What they say</h2>
                </div>{" "}
                {/* section title */}
              </div>
            </div>{" "}
            {/* row */}
            <div className="row testimonial-slied mt-40">
              <div className="col-lg-6">
                <div className="singel-testimonial">
                  <div className="testimonial-thum">
                    <img src="images/testimonial/t-1.jpg" alt="Testimonial" />
                    <div className="quote">
                      <i className="fa fa-quote-right" />
                    </div>
                  </div>
                  <div className="testimonial-cont">
                    <p>
                      Aliquetn sollicitudirem quibibendum auci elit cons equat
                      ipsutis sem nibh id elit. Duis sed odio sit amet sem nibh
                      id elit sollicitudirem{" "}
                    </p>
                    <h6>Rubina Helen</h6>
                    <span>Bsc, Engineering</span>
                  </div>
                </div>{" "}
                {/* singel testimonial */}
              </div>
              <div className="col-lg-6">
                <div className="singel-testimonial">
                  <div className="testimonial-thum">
                    <img src="images/testimonial/t-2.jpg" alt="Testimonial" />
                    <div className="quote">
                      <i className="fa fa-quote-right" />
                    </div>
                  </div>
                  <div className="testimonial-cont">
                    <p>
                      Aliquetn sollicitudirem quibibendum auci elit cons equat
                      ipsutis sem nibh id elit. Duis sed odio sit amet sem nibh
                      id elit sollicitudirem{" "}
                    </p>
                    <h6>Hero Gaur</h6>
                    <span>Bsc, Engineering</span>
                  </div>
                </div>{" "}
                {/* singel testimonial */}
              </div>
              <div className="col-lg-6">
                <div className="singel-testimonial">
                  <div className="testimonial-thum">
                    <img src="images/testimonial/t-3.jpg" alt="Testimonial" />
                    <div className="quote">
                      <i className="fa fa-quote-right" />
                    </div>
                  </div>
                  <div className="testimonial-cont">
                    <p>
                      Aliquetn sollicitudirem quibibendum auci elit cons equat
                      ipsutis sem nibh id elit. Duis sed odio sit amet sem nibh
                      id elit sollicitudirem{" "}
                    </p>
                    <h6>Rubina Helen</h6>
                    <span>Bsc, Engineering</span>
                  </div>
                </div>{" "}
                {/* singel testimonial */}
              </div>
            </div>{" "}
            {/* testimonial slied */}
          </div>{" "}
          {/* container */}
        </section>
        {/*====== TEASTIMONIAL PART ENDS ======*/}
        {/*====== PATNAR LOGO PART START ======*/}
        <div id="patnar-logo" className="pt-40 pb-80 gray-bg">
          <div className="container">
            <div className="row patnar-slied">
              <div className="col-lg-12">
                <div className="singel-patnar text-center mt-40">
                  <img src="images/patnar-logo/p-1.png" alt="Logo" />
                </div>
              </div>
              <div className="col-lg-12">
                <div className="singel-patnar text-center mt-40">
                  <img src="images/patnar-logo/p-2.png" alt="Logo" />
                </div>
              </div>
              <div className="col-lg-12">
                <div className="singel-patnar text-center mt-40">
                  <img src="images/patnar-logo/p-3.png" alt="Logo" />
                </div>
              </div>
              <div className="col-lg-12">
                <div className="singel-patnar text-center mt-40">
                  <img src="images/patnar-logo/p-4.png" alt="Logo" />
                </div>
              </div>
              <div className="col-lg-12">
                <div className="singel-patnar text-center mt-40">
                  <img src="images/patnar-logo/p-2.png" alt="Logo" />
                </div>
              </div>
              <div className="col-lg-12">
                <div className="singel-patnar text-center mt-40">
                  <img src="images/patnar-logo/p-3.png" alt="Logo" />
                </div>
              </div>
            </div>{" "}
            {/* row */}
          </div>{" "}
          {/* container */}
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default About;
